import type { MetricStat } from '../types';

const getMockRetentionStats = (): MetricStat[] => [
    {
        id: 'logo-churn',
        label: 'Logo churn',
        value: '3.6%',
        hint: 'Monthly',
        tone: 'neutral',
        iconKey: 'logoChurn',
    },
    {
        id: 'revenue-churn',
        label: 'Revenue churn',
        value: '2.1%',
        hint: 'MRR lost',
        tone: 'positive',
        iconKey: 'revenueChurn',
    },
    {
        id: 'retention-nrr',
        label: 'NRR',
        value: '108%',
        hint: 'Net revenue retention',
        tone: 'positive',
        iconKey: 'nrr',
    },
    {
        id: 'avg-lifetime',
        label: 'Avg lifetime',
        value: '28 mo',
        hint: '1 ÷ logo churn',
        tone: 'neutral',
        iconKey: 'avgLifetime',
    },
];

export default getMockRetentionStats;
